import { TealiumConfiguration } from "../instrumentation/tealium/tealium-config";
import { EncoreConfiguration } from "./encore-configuration.model";
import { ContentApiConfiguration } from "./content-api-configuration.model";

export class EnvironmentConfiguration{
    public rootUrl:string;
    public encoreConfiguration: EncoreConfiguration = new EncoreConfiguration();
    public applicationInsightsInstrumentationKey: string;
    public tealiumConfiguration: TealiumConfiguration = new TealiumConfiguration();
    public contentApiConfiguration: ContentApiConfiguration = new ContentApiConfiguration();
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/configuration/environment-configuration.model.ts